export default "__VITE_ASSET__a8b8e36d__"